import * as types from '../types'

export default {
    state: {
        teacherCourseData:{

        }
    },
    mutations: {
        [types.TEACHERCOURSEDATA]: (state, data) => {
            state.teacherCourseData = _.cloneDeep(data);
        },

    },
    getters: {

    },
    actions: {
    }
}